import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import { t } from 'ember-intl'
import SideNavItem from 'teacher-ui-client/components/side-nav/item'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'
import type LogoutService from 'teacher-ui-client/services/logout'
import { fn } from '@ember/helper'
import { on } from '@ember/modifier'
import appleUnfilled from '@images/icons/apple-unfilled.svg'

export class AccountLink extends Component {
  @service sideNav!: SideNavService
  @service logout!: LogoutService

  <template>
    {{#if this.sideNav.isHomeschool}}
      <li class="text-dusty-black-400 border-b-2 px-4 py-3 md:hidden" role="presentation">
        <button
          data-test-sidenav-accordion-label
          type="button"
          class="text-dusty-black-400 hover:text-dusty-black-400 flex w-full cursor-pointer items-center gap-3 text-left text-sm font-medium select-none"
          role="menuitem"
          {{on "click" (fn this.logout.logoutAndRedirectToReadingeggs "/parent_ui/my-account")}}
        >
          <SideNavIconComponent @url={{appleUnfilled}} @alt="Account" />

          {{t "sideNav.myAccount"}}</button>
      </li>
    {{else}}
      <SideNavItem @linkTo="subscription-type.account" class="md:hidden">
        <SideNavIconComponent @url={{appleUnfilled}} @alt="Account" />
        <span>{{t "sideNav.myAccount"}}</span>
      </SideNavItem>
    {{/if}}
  </template>
}

export default AccountLink
